import React from 'react';
import PropTypes from 'prop-types';
import { get, groupBy, uniq } from 'lodash';

import DebouncedQuery from 'components/DebouncedQuery';

import { queryNameForConfigType, queryForConfigType } from './constants';
import { configTypes } from '../constants';

const ConfigValueSuggestions = ({
  configType,
  searchValue,
  children,
  grouped,
  ...rest
}) => (
  <DebouncedQuery
    buildQueryVariables={() => ({ searchValue })}
    debounceMS={500}
    query={queryForConfigType[configType]}
    searchValue={searchValue}
    skipQuery={() => !searchValue}
  >
    {({ data, pending }) => {
      let suggestions = uniq(
        get(data, `${queryNameForConfigType[configType]}.values`) || [],
      );

      if (grouped) {
        suggestions = Object.entries(
          groupBy(suggestions.sort(), name => get(name, '0', '').toUpperCase()),
        );
      }

      return children({
        ...rest,
        suggestions,
        isLoading: pending,
      });
    }}
  </DebouncedQuery>
);

ConfigValueSuggestions.propTypes = {
  children: PropTypes.func.isRequired,
  configType: PropTypes.oneOf(Object.values(configTypes)).isRequired,
  grouped: PropTypes.bool.isRequired,
  searchValue: PropTypes.string,
};

ConfigValueSuggestions.defaultProps = { searchValue: undefined };

export default ConfigValueSuggestions;



// WEBPACK FOOTER //
// ./src/compositions/Reports/ReportConfigBuilder/InputFieldWithSuggestions/ConfigValueSuggestions.js